// extracted by mini-css-extract-plugin
export default {"cls1":"AutoCompleteResults-cls1_lX3","cls2":"AutoCompleteResults-cls2_gvl AutoCompleteResults-cls1_lX3"};